import { useLazyQuery } from "@apollo/client";
import * as Dialog from "@radix-ui/react-dialog";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "src/components/Button";
import Icon from "src/components/Icon";
import { CloseIcon } from "src/components/Icons";
import { GetEvent } from "src/graphql/queries";
import useAppStore from "src/store/utils";
import { event } from "src/types/api";
import AddBeneficiary from "./modals/AddBeneficiary";
import KYCVerify from "./modals/KYCVerify";

interface LocationState {
  from?: string;
  subFrom?: string;
}

const PaymentSetup = () => {
  const { event } = useAppStore((state) => state);

  const [getEvent] = useLazyQuery<event>(GetEvent, {
    variables: {
      eventId: event?.id,
    },
  });

  // const { data: profile } = useQuery(gql`
  //   query user {
  //     user {
  //       kyc_record {
  //         status
  //         bank_details {
  //           account_name
  //           account_number
  //           bank_name
  //         }
  //         country_iso
  //         status
  //         created_at
  //       }
  //     }
  //   }
  // `);

  const [paymentSetup, setPaymentSetup] = useState(false);

  // const setIsPaymentSetup = useContext(AppContext)?.setIsPaymentSetup;

  const [open, setOpen] = useState(false);

  const [kycOpen, setKycOpen] = useState(false);

  const location = useLocation();
  const state = location.state as LocationState;

  const navigate = useNavigate();

  const [verified, setVerified] = useState(false);

  const handleRefetchEvent = () => {
    getEvent({
      fetchPolicy: "network-only",
      onCompleted(data) {
        const eventData = data?.event?.enabled_currencies;
        setPaymentSetup((eventData ?? []).length > 0);
      },
    });
  };

  useEffect(() => {
    handleRefetchEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // const verified = profile?.user.kyc_record.status === "completed";

  // const [attachAsoebiPayment] = useMutation<
  //   AttachAseobiPayment,
  //   AttachAseobiPaymentVariables
  // >(ATTACH_ASOEBI_PAYMENT);

  // const [attachEventWalletToSubaccount] = useMutation<
  //   AttachEventWalletToSubaccount,
  //   AttachEventWalletToSubaccountVariables
  // >(ATTACH_EVENT_WALLET_TO_SUBACCOUNT);

  const handleRedirect = () => {
    if (state?.from === "aso-ebi") {
      navigate(state.subFrom ?? "/aso-ebi");
    } else if (state?.from === "cash-gifts") {
      navigate("/cash-gifts");
    } else {
      navigate(-1);
    }
  };

  const [bvn, setBvn] = useState("");

  return (
    <div className="relative h-screen bg-white p-8">
      <div className="flex h-full flex-col">
        <div className="flex items-center justify-between">
          <h1 className="text-xl">
            {state?.from === "cash-gifts"
              ? `Cash Gifts`
              : state?.from === "aso-ebi"
                ? `Aso Ebi`
                : ``}
          </h1>
          <div className="cursor-pointer" onClick={() => navigate(-1)}>
            <CloseIcon />
          </div>
        </div>

        <div className="flex flex-grow items-center justify-center">
          <div className="flex w-[450px] flex-col gap-6">
            <div className="">
              <h3 className="mb-2 text-xl font-semibold">Setup Naira</h3>
              <p className="text-sm text-[#707070] sm:text-base">
                Complete all these steps so you can receive cash gifts in
                multiple currencies
              </p>
            </div>

            <button
              className={`${verified || paymentSetup ? `cursor-not-allowed` : `cursor-pointer hover:scale-105 hover:border-gray-500`} rounded-md border border-gray-300 px-4 py-6 transition duration-500`}
              onClick={() => {
                (!verified || paymentSetup) && setKycOpen(true);
              }}
              disabled={verified || paymentSetup}
            >
              <div className="flex items-center gap-4">
                <span
                  className={`text-4xl text-[#d1d5db] ${verified || paymentSetup ? `text-green-500` : ``} `}
                >
                  <Icon iconName="circleCheck" />
                </span>
                <span className="text-left text-sm text-[#707070] sm:text-base">
                  Complete KYC for all these currencies
                </span>
              </div>
            </button>

            <button
              className={`${paymentSetup || !verified ? `cursor-not-allowed` : `cursor-pointer hover:scale-105 hover:border-gray-500`} rounded-md border border-gray-300 px-4 py-6 transition duration-500`}
              onClick={() => !paymentSetup && verified && setOpen(true)}
              // disabled={isPaymentSetup || !verified}
              disabled={paymentSetup && !verified}
            >
              <div className="flex items-center gap-4">
                <span
                  className={`text-4xl text-[#d1d5db] ${paymentSetup ? `text-green-500` : ``} `}
                >
                  <Icon iconName="circleCheck" />
                </span>
                <span className="text-left text-sm text-[#707070] sm:text-base">
                  Add your dedicated beneficiary account for all your
                  currencies. Note that you cash gifts are automatically sent
                  here
                </span>
              </div>
            </button>
            <Button
              label="I'm done"
              type="button"
              // disabled={!isPaymentSetup && !verified}
              disabled={!paymentSetup}
              onClick={handleRedirect}
            >
              I'm done
            </Button>
          </div>
        </div>
      </div>

      {/* <DialogModal open={kycOpen} onOpenChange={setKycOpen}>
        <KYCVerify
          bvn={bvn}
          setBvn={setBvn}
          setKycOpen={setKycOpen}
          setVerified={setVerified}
        />
      </DialogModal> */}

      <Dialog.Root open={kycOpen} onOpenChange={setKycOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed left-0 top-0 flex h-full w-full items-center justify-center gap-3 overflow-y-auto bg-[#00000080] px-4">
            <Dialog.Content>
              <KYCVerify
                bvn={bvn}
                setBvn={setBvn}
                setKycOpen={setKycOpen}
                setVerified={setVerified}
              />
            </Dialog.Content>
          </Dialog.Overlay>
        </Dialog.Portal>
      </Dialog.Root>

      <Dialog.Root open={open} onOpenChange={setOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed left-0 top-0 flex h-full w-full items-center justify-center gap-3 overflow-y-auto bg-[#00000080] px-4">
            <Dialog.Content>
              <AddBeneficiary
                bvn={bvn}
                setOpen={setOpen}
                setPaymentSetup={setPaymentSetup}
              />
            </Dialog.Content>
          </Dialog.Overlay>
        </Dialog.Portal>
      </Dialog.Root>

      {/* <DialogModal open={open} onOpenChange={setOpen}>
        <AddBeneficiary
          bvn={bvn}
          setOpen={setOpen}
          setPaymentSetup={setPaymentSetup}
        />
      </DialogModal> */}

      {/* <DialogModal open={kycOpen} onOpenChange={setKycOpen}>
        <KYCVerification setKycOpen={setKycOpen} setVerified={setVerified} />
      </DialogModal> */}
    </div>
  );
};

export default PaymentSetup;
